import apiUrl from '../../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs'
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
import {
	Validator
} from 'vee-validate'

export default {
	name: 'Grclotreport',
	components: {
		//Paginate,
		BasicSelect,
		Pagination,
		DatePicker,
		JsonExcel,
		download,
		Loader
	},
	data: function () {
		return {
			selectedmerchant: { value: '', text: '' },
			merchantList: [],
			merchantId: '',
			listMerchantIdData: [],
			merchantnameFlt: '',
			dataFilter2: '',

			csvFieldsForXls: {},
			listReportDataforxls: [],
			currentPage: 1,
			totalPage: 0,
			//totalCount:0,
			pageLimit: 10,

			totalRows: 0,
			// currentPage: 0,
			//modalShow used for close the active/inactive modal(default)
			listGrclotData: [],
			listWarehouseData: [],
			listGrcReportDataCsv: [],
			csvFields: [],
			datenow: '',
			// pageno: 0,
			// pageCount: 0,
			isLoading: false,
			searchFlag: false,
			showSelectMerchant: false,
			loginwarehouseid: '',
			Warehouse_obj: '',
			clientproductid: '',
			pono: '',
			POLineID: '',
			invoiceno: '',
			productname: '',
			productmrp: '',
			lotno: '',
			mfgdate: '',
			formattedDate: '',
			expdate: '',
			lotacceptedqty: '',
			lotrejectedqty: '',
			Grdatetime: '',
			fromdate: '',
			grfr_date: '',
			grto_date: '',
			lotfr_date: '',
			lotto_date: '',
			lotelotexpfr_date: '',
			lolotexpto_date: '',
			date: '',
			todate: '',
			grfromdate: '',
			grtodate: '',
			lotdate: '',
			lotfromdate: '',
			lottodate: '',
			lotexpdate: '',
			lotexpfromdate: '',
			lotexptodate: '',
			lot_exptodate: '',
			lot_expfromdate: '',
			resultCount: '',
			listClientData: [],
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			ClientErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			user_type: '',
			show: false,
			download: true,
			reportname: '',
			isLoadingforxls: false,
			limitExeed: false,
			recordLimit: 0,
			activemrpflag:false,
		}
	},
	created: function () { },
	// when a page loads,mounted() will be call
	mounted() {
		this.calldateFunction();
	
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		this.reportname = this.$t('editedjson.grclotreport');
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client;
		
		if(this.clientid!=='undefined'){
			this.getMerchantList();
		}

		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantList();
				this.getActiveMrpFlag();
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectMerchant = true;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

		this.time();
		this.getRecordLimit()
	},
	methods: {
		selectMerchant(data) {
			this.selectedmerchant = data;
			this.merchantnameFlt = data.value;
		},
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.grtodate = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.grfromdate = dt;
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},

		time() {
			// var self = this
			this.datenow = moment().format()
			// setInterval(self.time, 1000)
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			this.getGrclotreportDataForXls(3)
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {
		// 	if (this.clientid != this.client || this.clientid == this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantnameFlt = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.selectedmerchant = {}
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 			this.getActiveMrpFlag();
		// 			this.merchantList = []
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			this.selectedmerchant = {}
		// 			this.merchantList = []
		// 			this.getMerchantList();
		// 			this.getActiveMrpFlag();



		// 			// this.getGrclotreportData();
		// 		}



		// 	}
		// 	this.listGrclotData = []
		// 	this.listStockReportData = [];
		// 	this.pageno = this.pageCount = 0;
		// },


		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {

					this.listMerchantData = result.data;
					this.merchantList.push({
						value: '', text: this.$t('common.selectMerchantPlaceHolder')
					}
					)
					for (var i = 0; i < this.listMerchantData.length; i++) {
						// console.log( this.listMerchantData.merchantname[i],"merchname")
						this.merchantList.push({
							'value': this.listMerchantData[i].merchantid,
							'text': this.listMerchantData[i].merchantname
						});
					}
				}, error => {
					console.error(error);
				})
		},

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.pageCount = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// console.log(this.warehouse);
		// 			// this.getGrclotreportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },


		async getActiveMrpFlag(){
				 var userToken = window.localStorage.getItem('userToken');
				 var myStr = userToken.replace(/"/g, '');
				 this.input = ({
					 "clientid": this.clientid,
				 });
			 try {

					 axios({
							 method: 'POST',
							 'url': apiUrl.api_url + 'checkActivemrpFlg',
							 'data': this.input,
							 headers: {
								 'Authorization': 'Bearer ' + myStr,
							 }
						 })
						 .then(result => {
							 if(result.data.data.data[0].value ==='yes'){
								 this.activemrpflag = true;
							 }else{
								 this.activemrpflag = false;
							 }
						 }, error => {
							 console.error(error);
						 });

				 } catch (err) {
					 throw new Error(err);
				 }
	 },
		getGrclotreportDataSearch() {
			this.currentPage = 1;
			this.pageCount = 0;
			this.searchFlag = true;
			this.getGrclotreportData(2);
		},
		//to get Stock list
		getGrclotreportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var grfr_date = '';
			var grto_date = '';
			var lotfr_date = '';
			var lotto_date = '';
			var lotexpfr_date = '';
			var lotexpto_date = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageno = this.pageCount = 0;
				this.listGrclotData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageno = this.pageCount = 0;
				this.listGrclotData = [];
				return false;
			}
			this.isLoading = true;
			if (this.grfromdate) {
				grfr_date = this.dateFormat(this.grfromdate, 0)
			}

			if (this.grtodate == '') {
				grto_date = '';
			} else {
				grto_date = this.dateFormat(this.grtodate, 1)
			}

			if (this.lotfromdate) {
				lotfr_date = this.dateFormat(this.lotfromdate, 0)
			}
			if (this.lottodate == '') {
				lotto_date = '';
			} else {
				lotto_date = this.dateFormat(this.lottodate, 1)
			}

			if (this.lotexpfromdate) {
				lotexpfr_date = this.dateFormat(this.lotexpfromdate, 0)
			}
			if (this.lotexptodate == '') {
				lotexpto_date = '';
			} else {
				lotexpto_date = this.dateFormat(this.lotexptodate, 1)
			}


			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				grfromdate: grfr_date,
				grtodate: grto_date,
				lotfromdate: lotfr_date,
				lottodate: lotto_date,
				lotexpfromdate: lotexpfr_date,
				lotexptodate: lotexpto_date,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				invoiceno: this.invoiceno,
				pono: this.pono,
				clientproductid: this.clientproductid,
				lotno: this.lotno,
				createddate: this.createddate,
				csvData: csvCheck,
				clientid: this.clientid,
				merchantid: this.merchantnameFlt,

			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getgrclotReportList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						this.show = true;
						this.download = false;
						this.csvFields = {
							'warehouseid':  this.$t('common.warehouseID'),
							'invoiceno': this.$t('config.invoice'),
							'pono': this.$t('removeHold.poId'),
							'poitemid': this.$t('editedjson.poLineID'),
							'clientproductid': this.$t('printProductDetails.clientProductId'),
							'productname': this.$t('printProductDetails.productName'),
							'mrp': this.$t('stockTransfer.productMrp'),
							'activemrp': this.$t('common.activemrp'),
							'hsncode': this.$t('productPlaceHolder.hsnCodePlaceHolder'),
							'hsnrate': this.$t('grcLotReport.hsnRate'),
							'manufacturedate': this.$t('grcLotReport.manufactureDate'),
							'expirydate': this.$t('printProductDetails.expiryDate'),
							'acceptedlotqty': this.$t('grcLotReport.acceptedLotQTY'),
							'rejectedlotqty': this.$t('grcLotReport.rejectedLotQTY'),
							'lotno':  this.$t('grcList.lotNo'),
							'createddate':  this.$t('common.createdDate'),
							'merchantname': this.$t('common.merchant'),

						};
						var dateFilter = [];
						if(this.activemrpflag === true){
								var skipFilter = ['count', 'ManufactureDate', 'ExpiryDate', 'merchantid'];
						}else {
							   var skipFilter = ['count', 'ManufactureDate', 'ExpiryDate', 'merchantid','activemrp'];
						}
						this.listGrcReportDataCsv = result.data.data;

						csvHelper.data.jsonToCSV(this.$t('editedjson.grclotreport'), this.listGrcReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

						// this.jsonToCSV('Grclotreport', this.listGrcReportDataCsv, this.csvFields, dateFilter, skipFilter);

					} else {
						this.listGrclotData = result.data.data;

						if (result.data.errorCode == -1) {
							this.resultCount = 0
						} else {
							this.totalRows = Number(result.data.count)
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							// console.log(this.totalRows);
							this.resultCount = result.data.count
							if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10)
							}

						}
					}
					this.isLoading = false;
				},
					error => {
						this.isLoading = false;
						console.error(error)
					})

		},
		getGrclotreportDataForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var grfr_date = '';
			var grto_date = '';
			var lotfr_date = '';
			var lotto_date = '';
			var lotexpfr_date = '';
			var lotexpto_date = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			// this.ClientErr = '';

			if (this.grfromdate) {
				grfr_date = this.dateFormat(this.grfromdate, 0)
			}

			if (this.grtodate == '') {
				grto_date = '';
			} else {
				grto_date = this.dateFormat(this.grtodate, 1)
			}

			if (this.lotfromdate) {
				lotfr_date = this.dateFormat(this.lotfromdate, 0)
			}
			if (this.lottodate == '') {
				lotto_date = '';
			} else {
				lotto_date = this.dateFormat(this.lottodate, 1)
			}

			if (this.lotexpfromdate) {
				lotexpfr_date = this.dateFormat(this.lotexpfromdate, 0)
			}
			if (this.lotexptodate == '') {
				lotexpto_date = '';
			} else {
				lotexpto_date = this.dateFormat(this.lotexptodate, 1)
			}

			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				grfromdate: grfr_date,
				grtodate: grto_date,
				lotfromdate: lotfr_date,
				lottodate: lotto_date,
				lotexpfromdate: lotexpfr_date,
				lotexptodate: lotexpto_date,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				invoiceno: this.invoiceno,
				pono: this.pono,
				clientproductid: this.clientproductid,
				lotno: this.lotno,
				createddate: this.createddate,
				csvData: csvCheck,
				clientid: this.clientid,
				merchantid: this.merchantnameFlt,


			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getgrclotReportList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls =[];
							this.csvFieldsForXls[this.$t('common.warehouseID')] ='warehouseid';
							this.csvFieldsForXls[this.$t('config.invoice')] = 'invoiceno';
							this.csvFieldsForXls[this.$t('removeHold.poId')] = 'pono';
							this.csvFieldsForXls[this.$t('editedjson.poLineID')] =  'poitemid';
							this.csvFieldsForXls[this.$t('product.clientProductId')] = 'clientproductid';
							this.csvFieldsForXls[this.$t('printProductDetails.productName')] =  'productname';
							this.csvFieldsForXls[this.$t('stockTransfer.productMrp')] =  'mrp';
							if(this.activemrpflag === true){
								this.csvFieldsForXls[this.$t('common.activemrp')] =  'activemrp';
							}
							this.csvFieldsForXls[this.$t('productPlaceHolder.hsnCodePlaceHolder')] = 'hsncode';
							this.csvFieldsForXls[this.$t('grcLotReport.hsnRate')] = 'hsnrate';
							this.csvFieldsForXls[this.$t('grcLotReport.manufactureDate')] = 'manufacturedate';
							this.csvFieldsForXls[this.$t('printProductDetails.expiryDate')] = 'expirydate';
							this.csvFieldsForXls[this.$t('grcLotReport.acceptedLotQTY')] = 'acceptedlotqty';
							this.csvFieldsForXls[this.$t('grcLotReport.rejectedLotQTY')] = 'rejectedlotqty';
							this.csvFieldsForXls[this.$t('grcList.lotNo')] = 'Rejected LOT QTY ';
							this.csvFieldsForXls[this.$t('common.createdDate')] = 'createddate';
							this.csvFieldsForXls[this.$t('common.merchant')] = 'merchantname';

							this.listReportDataforxls = result.data.data;

						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}

				},
					error => {
						this.isLoading = false;
						console.error(error)
					})

		},
		//to reset search form
		resetForm() {
			this.getMerchantList();
			this.merchantnameFlt = '';
			this.show = false;
			this.download = true;
			this.pono = '';
			this.invoiceno = '';
			this.clientproductid = '';
			this.lotno = '';
			this.todate = '';
			this.fromdate = '';
			this.grfromdate = '';
			this.grtodate = '';
			this.lotfromdate = '';
			this.lottodate = '';
			this.lotexpdate = '';
			this.lotexpfromdate = '';
			this.lotexptodate = '';
			this.listGrclotData = [];
			this.totalRows = 0;
			this.pageno = this.pageCount = 0;
			this.searchFlag = false;
			this.resultCount = 0;
			this.selectedmerchant = {}
			this.merchantList = []
			
		

			// this.getGrclotreportData();
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
		},
		onPageChange(page) {
			this.currentPage = page;
			this.getGrclotreportData()
		},
	},



}



// WEBPACK FOOTER //
// ./src/views/components/reports/grclotreport/grclotreport.component.js